import axios from "axios";
import {getV1URL} from "./API";

export default function login(username, password) {
    return axios.post(getV1URL("auth/sign-in"), {
        "username": username,
        "password": password,
    })
}